import { render } from "./VideoCommentReplies.vue?vue&type=template&id=0f116842&scoped=true"
import script from "./VideoCommentReplies.vue?vue&type=script&lang=js"
export * from "./VideoCommentReplies.vue?vue&type=script&lang=js"

import "./VideoCommentReplies.vue?vue&type=style&index=0&id=0f116842&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f116842"]])

export default __exports__